import React, { Component } from 'react';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';

class SearchDropdown extends Component {
  constructor(props) {
    super(props);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }
  /*:: toggleDropdown: () => void */


  toggleDropdown() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  render() {
    return /*#__PURE__*/React.createElement(Dropdown, {
      isOpen: this.state.dropdownOpen,
      toggle: this.toggleDropdown
    }, /*#__PURE__*/React.createElement(DropdownToggle, {
      "data-toggle": "dropdown",
      tag: "a",
      className: "nav-link dropdown-toggle arrow-none mr-0",
      onClick: this.toggleDropdown,
      "aria-expanded": this.state.dropdownOpen
    }, /*#__PURE__*/React.createElement("i", {
      className: "mdi mdi-magnify noti-icon"
    })), /*#__PURE__*/React.createElement(DropdownMenu, {
      right: true,
      className: "dropdown-menu-animated topbar-dropdown-menu dropdown-lg"
    }, /*#__PURE__*/React.createElement("form", {
      className: "p-3"
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: "form-control",
      placeholder: "Search ..."
    }))));
  }

}

export default SearchDropdown;